<template>
    <el-carousel
        class="h-100"
        :interval="5000"
        indicator-position="none"
        arrow="never">
        <el-carousel-item
            v-for="(image, index) in validImages"
            :key="index">
            <img
                :src="image.urlSm || image.url"
                alt="Image placeholder"
                class="img-fit"
                :style="'object-position: '+ image.imageCenter || 'center center'">
            <ImageLicence
                v-if="image.licence"
                :licence="image.licence" />
        </el-carousel-item>
    </el-carousel>
</template>

<script>

export default {
    name: "EventEntryImage",
    props: {
        images: {
            type: Array,
            required: true
        }
    },
    computed: {
        validImages() {
            return this.images?.filter(image => !!image.url)
        }
    }
}
</script>

<style lang="scss" scoped>
.img-fit {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

::v-deep {
    .el-carousel__container {
        height: 100% !important;
    }
}
</style>
